<template>
  <base-draggable-modal
      name="create_standard_deviation"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="create_standard_deviation">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <template v-for="field in usual_fields">
              <v-autocomplete
                  v-if="field.name === 'deviation_text'"
                  density="default"
                  class="reg-normal text-primary mt-3"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  color="primary"
                  v-model="record.deviation_text"
                  :items="deviation_texts"
                  @update:model-value="updateStandardDeviationValues(record.deviation_text)"
                  hide-details
                  clearable>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('deviation_text') }}<strong>*</strong></span>
                </template>
              </v-autocomplete>
              <base-field
                  v-else-if="field.name !== 'defect_id' && field.name !== 'company_priority'"
                  :key="field.name"
                  :modelValue="record[field.name]"
                  :field="field"
                  @change="usualFieldDataChanged"/>
            </template>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseActionButton from "../../components/commonComponents/BaseActionButton";
import { PhFloppyDisk, PhX } from "@phosphor-icons/vue";

export default {
  props: ["selected"],
  components: {BaseActionButton, BaseModal, BaseDraggableModal, PhFloppyDisk, PhX },
  data() {
    return {
      page: helpFunctions.pages.standarddeviations,
      record: {},
      deviation_templates: [],
      deviation_texts: [],
      usual_fields: [],
    };
  },

  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.record = {};
      this.openModal('create_standard_deviation');
      await this.loadDeviationTemplates();
      await this.getFields();
    },
    async loadDeviationTemplates() {
      this.deviation_templates = await helpFunctions.getFullAdditionalModels(this.$toast, "deviationtemplate");
      this.deviation_templates.forEach(deviation_template => {
        this.deviation_texts.push(deviation_template.deviation_text);
      });
      this.findDeviationText();
    },
    async save() {
      this.$store.dispatch('setLoader', true);
      for (let i = 0; i < this.selected.length; i++) {
        this.record.defect_id = this.selected[i].id;
        this.record.company_priority = this.selected[i].company_priority;
        await helpFunctions.createModelSilently("standarddeviations", this.record);
      }
      this.$store.dispatch('setLoader', false);
      this.$toast.success(this.$store.getters.translate("successfully_saved"));
      this.$emit('refresh');
      this.reset();
    },
    usualFieldDataChanged(data) {
      this.record[data[0]] = data[1];
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, "show_on_creation");
      this.usual_fields = response.usual_fields || [];
    },
    findDeviationText() {
      for (let x = 0; x < this.selected.length; x++) {
        if(this.selected[x].deviations_and_remarks && this.updateStandardDeviationValues(this.selected[x].deviations_and_remarks)) {
          break;
        }
      }
    },
    updateStandardDeviationValues(deviations_and_remarks) {
      if(deviations_and_remarks) {
        let deviations_and_remark_cleaned = deviations_and_remarks.toLowerCase().replace(/[^a-z0-9]/g, '');

        for (let i = 0; i < this.deviation_templates.length; i++) {
          let deviation_text_cleaned = this.deviation_templates[i].deviation_text.toLowerCase().replace(/[^a-z0-9]/g, '');
          if (deviations_and_remark_cleaned.includes(deviation_text_cleaned) || deviation_text_cleaned.includes(deviations_and_remark_cleaned)) {
            this.record.deviation_text = this.deviation_templates[i].deviation_text;
            this.record.average_hours_to_repair = this.deviation_templates[i].average_hours_to_repair;
            this.record.engineer_qualification = this.deviation_templates[i].engineer_qualification;
            this.record.commissioning_qualification = this.deviation_templates[i].commissioning_qualification;
            this.record.technician_qualification = this.deviation_templates[i].technician_qualification;
            this.record.technical_authority_qualification = this.deviation_templates[i].technical_authority_qualification;
            this.record.work_preparation_qualification = this.deviation_templates[i].work_preparation_qualification;
            return true;
          }
        }
      }

      return false;
    },
    reset() {
      this.record = {};
      this.closeModal('create_standard_deviation');
    },
  }
};
</script>